module.exports = __webpack_public_path__ + "static/media/PM61.9afa76e7.JPG";